<carousel style="z-index: 0;width: 90%;"  [height]="420" [cellWidth]="350" [arrowsOutside]="!IsMobile" >
    <div class="carousel-cell"
        *ngFor="let paragraphe of ParagrapheArrayOE | slice:1:ParagrapheArrayOE.length-1">
        <app-emploi [url]="url" [Job]="paragraphe"></app-emploi>
    </div>
</carousel>
